import { IOverlayStageVM } from 'components/overlay/overlayStage.interfaces';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import overlayManager from 'managers/overlay';
import { EffectsContainer } from 'mixins/withEffects';
import CommunityNavigationWidgetItemModel from '../item';
import CommunityNavigationWidgetVM from '../navigation';
import './navigation.html';

const animationDuration = 650;

components
    .registerLocal('community-navigation-mobile-item', () => require('./item'))
    .registerLocal('community-navigation-mobile-group', () => require('./group'));

@injectable()
export default class CommunityMobileNavigationWidgetVM {
    private stage = ko.observable<IOverlayStageVM>();

    hidden = ko.observable(false);

    items: Subscribable<Array<CommunityNavigationWidgetItemModel>>
    visible: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) root: CommunityNavigationWidgetVM,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.items = root.mobileLinks;
        this.visible = this.hidden.not();
        
        effects.register(stage => {
            if (stage != undefined)
                return () => stage.close();
        }, [this.stage]);

        ko.applyBindingsToNode(info.element, {
            'visible': this.items.any(),

            'css': {
                'community__mobile-navigation': true
            }
        });
    }

    async show() {
        this.hidden(false);

        const stage = await overlayManager.toOverlay({ id: 'wcc-components-community-navigation-mobile-popup' }, {
            fullscreen: true,
            lock: true,
            data: this
        });

        this.stage(stage);
    }

    hide() {
        this.hidden(true);

        setTimeout(() => this.stage(undefined), animationDuration);
    }

    //onBodyClick(m, e) {
    //    let $target = $(e.target),
    //        $link = $target.closest('community-navigation-link');

    //    if (!$link.hasClass('navigation-group-header'))
    //        this.hide();
    //}
}